import { Suspense } from "react";
import { withTranslation } from "react-i18next";
import { BrowserRouter as Router } from "react-router-dom";
import Loader from "./components/shared/Loader";
import Routers from "./routing/Routes";

function App() {
  return (
    <Router>
      <Suspense fallback={<Loader />} >
        <Routers />
      </Suspense>
    </Router>
  )
}

export default withTranslation()(App);
